import { render } from "./SkuNote.vue?vue&type=template&id=48e46d1e"
import script from "./SkuNote.vue?vue&type=script&lang=js"
export * from "./SkuNote.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__